import { render } from "./ModalPurchasesInfo.vue?vue&type=template&id=5b913e4e&scoped=true&ts=true"
import script from "./ModalPurchasesInfo.vue?vue&type=script&lang=ts"
export * from "./ModalPurchasesInfo.vue?vue&type=script&lang=ts"

import "./ModalPurchasesInfo.vue?vue&type=style&index=0&id=5b913e4e&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b913e4e"]])

export default __exports__